module.exports = __webpack_public_path__ + "assets/roadmap.39549dd9.svg";